import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Input, Modal, PageHead, useToast } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

type Run = { _id: string; runs: number }

export function RunListPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const [list, setList] = useState<Run[]>([])
  const [open, setOpen] = useState(false)
  const [runs, setRuns] = useState('')
  const [deleteId, setDeleteId] = useState<string | null>(null)

  const load = () => {
    void sessionApi.getAllRuns().then((res) => {
      setList(Array.isArray(res.data) ? (res.data as Run[]) : [])
    })
  }

  useEffect(() => {
    load()
  }, [])

  return (
    <div>
      <PageHead
        title="Run List"
        onBack={() => navigate('/sessionmarket')}
        actions={
          <Button variant="primary" onClick={() => setOpen(true)}>
            Create Run
          </Button>
        }
      />
      <div className="sm-card">
        <table className="w7-table">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Runs</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {!list.length ? (
              <tr>
                <td colSpan={3}>No Runs found</td>
              </tr>
            ) : (
              list.map((run, i) => (
                <tr key={run._id}>
                  <td>{i + 1}</td>
                  <td>{run.runs}</td>
                  <td>
                    <Button size="sm" variant="danger" onClick={() => setDeleteId(run._id)}>
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Create Run"
        footer={
          <Button
            variant="primary"
            onClick={() =>
              void sessionApi
                .saveRun({ runs: Number(runs) })
                .then(() => {
                  toast.success('Run saved')
                  setOpen(false)
                  setRuns('')
                  load()
                })
                .catch(() => toast.error('Failed'))
            }
          >
            Save
          </Button>
        }
      >
        <Input type="number" value={runs} onChange={(e) => setRuns(e.target.value)} placeholder="Runs" />
      </Modal>

      <Modal
        open={!!deleteId}
        onClose={() => setDeleteId(null)}
        title="Delete Run"
        footer={
          <Button
            variant="danger"
            onClick={() => {
              if (!deleteId) return
              void sessionApi.deleteOneRun(deleteId).then(() => {
                toast.success('Run deleted Successfully')
                setDeleteId(null)
                load()
              })
            }}
          >
            Delete
          </Button>
        }
      >
        <p>Delete this run?</p>
      </Modal>
    </div>
  )
}
